import React from 'react'
import { Component } from 'react'
import { Navigate } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'
import { Link } from "react-router-dom";

export default class AuthorizeRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      authenticated: false,
      authorized: false
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.authenticationChanged());
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  render() {
    const { ready, authenticated, authorized } = this.state;
    var link = document.createElement("a");
    link.href = this.props.path;
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;
    if (!ready) {
      return <div></div>;
    } else {
      const { element } = this.props;
      if (!authenticated) {
        return <Navigate replace to={redirectUrl} />;
      }

      return authorized ? element : <Navigate replace to="/" />;
        //return authenticated ? element : <Link to={redirectUrl} />;
    }
  }

  async populateAuthenticationState() {
    const authenticated = await authService.isAuthenticated();
    let authorized = authenticated;

    if (authenticated && this.props.requiredRole) {
      try {
        const token = await authService.getAccessToken();
        const response = await fetch('api/Usuarios/GetRole', {
          headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const role = response.ok ? await response.text() : '';
        authorized = role === this.props.requiredRole;
      } catch {
        authorized = false;
      }
    }

    this.setState({ ready: true, authenticated, authorized });
  }

  async authenticationChanged() {
    this.setState({ ready: false, authenticated: false, authorized: false });
    await this.populateAuthenticationState();
  }
}
